import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import NavDrawer from '../mentorComponents/navDrawer/NavDrawer'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ApartmentIcon from '@mui/icons-material/Apartment';
import CodeIcon from '@mui/icons-material/Code';
import RateReviewIcon from '@mui/icons-material/RateReview';
import AssignmentIcon from '@mui/icons-material/Assignment';
import EngineeringIcon from '@mui/icons-material/Engineering';
import HubIcon from '@mui/icons-material/Hub';
import WidgetsIcon from '@mui/icons-material/Widgets';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import PieChartIcon from '@mui/icons-material/PieChart';
import AccessTimeIcon from '@mui/icons-material/AccessTime';


function AdminDashboard() {
  const { coeName } = useParams();
  const [user, setUser] = React.useState({});
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUser(userData);

  }, []);
  const basePath = '/admin';

  const menuItems = [
    ...(user.role === 'super_admin'
      ? [{ label: 'Admin', icon: <AdminPanelSettingsIcon />, path: `${basePath}/add-admin` }]
      : []),
    ...(user.role !== 'coe_report_admin'
      ? [
        { label: 'COE Center', icon: <ApartmentIcon />, path: `${basePath}/coe-center` },
        { label: 'Lab Practice', icon: <CodeIcon />, path: `${basePath}/lab-practice` },
      ]
      : []),
    { label: 'Learner Reviews', icon: <RateReviewIcon />, path: `${basePath}/learner-reviews` },
    { label: 'Learner Practices', icon: <AssignmentIcon />, path: `${basePath}/learner-practices` },
    ...(user.role !== 'coe_report_admin'
      ? [
        { label: 'Practice Mentor', icon: <EngineeringIcon />, path: `${basePath}/practice-mentor` },
        ...(user.role === 'super_admin' ? [{ label: 'QMS', icon: <HubIcon />, path: `${basePath}/qms` }] : []),
        { label: 'Maker Module', icon: <WidgetsIcon />, path: `${basePath}/maker-module` },
        { label: 'Maker Plan', icon: <CalendarMonthIcon />, path: `${basePath}/maker-plan` }
      ]
      : []),

    {
      label: 'Daily Report',
      icon: <AssessmentIcon />,
      path: `${basePath}/daily-report`,
    },
    ...(user.role !== 'coe_report_admin'
      ? [{ label: 'Lab Report', icon: <AnalyticsIcon />, path: `${basePath}/lab-report` }]
      : []),
    { label: 'Coder Distribution', icon: <PieChartIcon />, path: `${basePath}/coder-distribution` },
    { label: 'CheckIn-Out Report', icon: <AccessTimeIcon />, path: `${basePath}/checkIn-out-report` }
  ];


  return (
    <div>
      <NavDrawer menuItems={menuItems} />
    </div>
  )
}

export default AdminDashboard